<template>
  <div class="loading-state" role="status" aria-label="Загрузка">
    <span class="sr-only">Загружаем данные…</span>
  </div>
</template>
